// extracted by mini-css-extract-plugin
export var billingAddress = "_r2-g";
export var contactInfo = "_r2-d";
export var customerInfoContainer = "_r2-c";
export var customerInfoContainerMobile = "_r2-h";
export var customerInfoRow = "_r2-a";
export var customerInfoSection = "_r2-b";
export var fullWidthDividerMobile = "_r2-i";
export var imageContainer = "_r2-1";
export var paymentMethod = "_r2-e";
export var priceText = "_r2-6";
export var priceTextMobile = "_r2-7";
export var product = "_r2-0";
export var productImage = "_r2-2";
export var productInfo = "_r2-4";
export var productMobile = "_r2-9";
export var productTitle = "_r2-8";
export var quantityBadge = "_r2-3";
export var quantityText = "_r2-5";
export var shippingAddress = "_r2-f";